import { BaseQueryFn, EndpointBuilder, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { ResponseWebsiteDto, Website } from '../types/dtos';
import { APP_ENDPOINTS } from 'app/endpoints';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<Website, string>({
        async queryFn(websiteId, _queryApi, _extraOptions, fetchWithBQ) {
            const websiteResult = await fetchWithBQ(`${APP_ENDPOINTS.WEBSITE}/${websiteId}`);

            if (websiteResult.error) return { error: websiteResult.error as FetchBaseQueryError };

            const website = websiteResult.data as ResponseWebsiteDto;

            return {
                data: website,
            };
        },
        providesTags: [{ type: 'website', id: 'GET-ID' }],
    });
